import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = not authed, object = authed
  const [user, setUser] = useState(null);
  const [accessGranted, setAccessGranted] = useState(
    typeof window !== "undefined" && sessionStorage.getItem("arjuna_key_ok") === "1"
  );

  const grantAccess = () => {
    sessionStorage.setItem("arjuna_key_ok", "1");
    setAccessGranted(true);
  };

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    sessionStorage.removeItem("arjuna_key_ok");
    setAccessGranted(false);
    setUser(false);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, login, register, logout, checkAuth, accessGranted, grantAccess }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { formatApiErrorDetail };
